import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCompareFill = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("switch", { children: /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", { d: "M25.5 16.064h9.816v-3H12.685v3H22.5v23.311h-6.157v3h15.315v-3H25.5zm-3-10.439h3V11.2h-3z" }), /* @__PURE__ */ _jsx("path", { d: "m35.901 18.665-6.935 11.917 6.935 2.744 6.934-2.744zm-23.801 0L5.166 30.582l6.934 2.744 6.934-2.744z" })] }) })
});
export default SvgCompareFill;
